/*
 * @Author: Vir
 * @Date: 2022-04-02 11:52:46
 * @Last Modified by: Vir
 * @Last Modified time: 2022-04-02 17:10:29
 */

import React, { FC } from 'react';

const ContentLinkList: FC<any> = ({ children }) => {
  return <div className="my-6">{children}</div>;
};

export default ContentLinkList;
